import { useId } from "react";
import { Props_SnippetCards } from "./Cards.props";
import SnippetLink from "../Shared/Link/Link";

const Cards = (props: Props_SnippetCards) => {
    const { heading, repeatable_cards: cards } = props;
    const id = useId();
    const classHeadingVisibility: string = heading.visibility?.value ? 'snippet-cards__heading--visible' : 'snippet-cards__heading--hidden';

    return (
        <section className="snippet-cards">
            <div className="snippet-cards__container">
                <h2 className={`snippet-cards__heading ${classHeadingVisibility}`}>
                    {heading.content.value}
                </h2>

                <ul className="snippet-cards__container-cards">
                    {cards.map(({ cardType, image, imageAltText, cardTitle, hoverTitle, linkHref, linkText, linkStyle, linkTarget, linkAriaLabel }, index) => {
                        const isIcon = cardType?.value === "icon";
                        const hasHoverContent = !!(hoverTitle?.value || linkText?.value);
                        const cardClass = `snippet-cards__card ${isIcon ? "snippet-cards__card--icon" : "snippet-cards__card--image"}${hasHoverContent ? " snippet-cards__card--hoverable" : ""}`;

                        return (
                            <li key={`card-${index}-${id}`} className={cardClass}>
                                <div className="snippet-cards__card-face">
                                    {!isIcon && image?.value && (
                                        <figure className="snippet-cards__card-container-image">
                                            <img
                                                src={image.value}
                                                alt={imageAltText?.value || ""}
                                                className="snippet-cards__card-image"
                                                loading="lazy"
                                                height="120"
                                                width="180"
                                            />
                                        </figure>
                                    )}

                                    <div className="snippet-cards__card-body">
                                        {isIcon && image?.value && (
                                            <figure className="snippet-cards__card-container-icon">
                                                <img
                                                    src={image.value}
                                                    alt={imageAltText?.value || ""}
                                                    className="snippet-cards__card-icon"
                                                    loading="lazy"
                                                    height="100"
                                                    width="100"
                                                />
                                            </figure>
                                        )}
                                        {cardTitle?.value && (
                                            <p className="snippet-cards__card-title">{cardTitle.value}</p>
                                        )}
                                    </div>
                                </div>

                                <div className="snippet-cards__card-hover">
                                    <div className="snippet-cards__card-hover-content">
                                        {hoverTitle?.value && (
                                            <p className="snippet-cards__card-hover-title">{hoverTitle.value}</p>
                                        )}
                                        <SnippetLink
                                            url={linkHref?.value}
                                            className="snippet-cards__card-hover-link"
                                            linkStyles={linkStyle?.value}
                                            openInNewTab={linkTarget?.value}
                                            aria-label={linkAriaLabel?.value || linkText?.value}
                                        >
                                            {linkText?.value}
                                        </SnippetLink>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};

export default Cards;
